module.exports = __webpack_public_path__ + "img/shoppingCart_purple.03acd61d.svg";